module.exports = __webpack_public_path__ + "img/GazEuropeen_120X35.a85514e1.png";